import { InjectionToken } from '@angular/core';

export interface RwcTranslationConfig {
    suppressWarnings?: boolean;
}

export const RWC_TRANSLATION_CONFIG = new InjectionToken<RwcTranslationConfig>(
    'Configuration for the RWC Translation service',
    {
        providedIn: 'root',
        factory: () => ({
            suppressWarnings: false
        })
    }
);

export const provideRwcTranslationConfig = (translationConfig: RwcTranslationConfig) => ({
    provide: RWC_TRANSLATION_CONFIG,
    useValue: translationConfig
});
